// const API_URL = "http://localhost:3005"
const API_URL = "https://server.ibes.ma"

export default API_URL
